import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // value: window.localStorage.getItem("theme") || "dark",
  value: "dark",
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    switchTheme: (state, action) => {
      state.value = action.payload;
      window.localStorage.setItem("theme", action.payload);
    },
  },
});

export const { switchTheme } = themeSlice.actions;

export const selectTheme = (state) => state.theme.value;

export default themeSlice.reducer;
